import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'tsMutateToAny', pure: true })
export class TsMutateToAnyPipe implements PipeTransform {
  transform(value: unknown, mutationFn: (target: unknown) => any): any {
    return mutationFn(value);
  }
}
